<template>
	<div class="login">
		<h1 class="headline">Log In to Mafia</h1>

		<form class="md-layout" @submit.prevent="login">
			<md-field :class="{ 'md-invalid': username && !isValidLogin }">
				<md-input v-model="username" name="username" placeholder="Username"></md-input>
				<span class="md-error">Username must contain only letters and numbers.</span>
			</md-field>

			<md-checkbox v-model="remember">Remember me</md-checkbox>

			<md-button class="md-raised md-primary" type="submit" :disabled="!isValidLogin">Enter</md-button>
		</form>
	</div>
</template>

<script>
export default {
	name: 'login',
	data() {
		let username = ''

		if (typeof localStorage != 'undefined') {
			username = localStorage.getItem('username') || ''
		}

		return {
			username,
			remember: !!username,
			hasError: false
		}
	},
	computed: {
		isValidLogin() {
			return /^[a-zA-Z0-9]+$/.test(this.username)
		}
	},
	methods: {
		login() {
			if (!this.isValidLogin) {
				return
			}

			if (this.remember) {
				localStorage.setItem('username', this.username)
			} else {
				localStorage.removeItem('username')
			}

			this.$store.dispatch('setUsername', this.username)
			this.$store.dispatch('getRoomData')
		}
	}
}
</script>

<style scoped>
form {
	display: flex;
	flex-flow: column;
}

form button {
	margin-left: 0;
	margin-right: 0;
}
</style>
